import Modal from "../../../components/Modal/Modal"
import styles from './GivewayParticipateModal.module.css'
import { ReactComponent as TicketIcon } from '../../../assets/userInfo/ticket.svg'
import React, { useRef, useState } from "react";
import { useModalStore } from "../../../store/ModalStore";

const GivewayParticipateModal = () => {

    const [couponAmount, setCouponAmount] = useState<number>(1);
    const [isFirstInput, setIsFirstInput] = useState<boolean>(true);
    const currentAmountRef = useRef<number>(1);
    const inputRef = useRef<HTMLInputElement>(null);
    const handleClose = useModalStore((state) => state.handleClose);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;

        if (inputValue === "") {
            const defaultValue = 5;
            setCouponAmount(defaultValue);
            currentAmountRef.current = defaultValue;
            setIsFirstInput(true);
            return;
        }

        const value = parseInt(inputValue, 10);

        if (isNaN(value) || value <= 0) {
            const defaultValue = 5;
            setCouponAmount(defaultValue);
            currentAmountRef.current = defaultValue;
            setIsFirstInput(true);
            return;
        }


        setCouponAmount(value);
        currentAmountRef.current = value;

    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (isFirstInput && e.key >= "0" && e.key <= "9") {
            e.preventDefault();
            const value = parseInt(e.key, 10);
            setCouponAmount(value);
            setIsFirstInput(false);
        }
    };

    const handleBlur = () => {
        setCouponAmount(Math.min(couponAmount, 9999));
    };

    const handleQuickSelect = (amount: number) => {
        setCouponAmount(amount);
        currentAmountRef.current = amount;
    };

    return (
        <Modal>
            <div className={styles.container}>
                <div className={styles.textContainer}>
                    <div className={styles.textTitle}>
                        Введите количество
                    </div>
                    <div className={styles.textSubtitle}>
                        Один билет равняется одному шансу на выигрыш от общего количества
                    </div>
                </div>
                <div className={styles.inputContainer}>
                    <input
                        ref={inputRef}
                        type="number"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className={styles.couponInput}
                        value={couponAmount}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                        onBlur={handleBlur}
                        maxLength={4}
                    />
                    <div className={styles.iconContainer}><TicketIcon /></div>
                </div>
                <div className={styles.quickSelect}>
                    <button
                        className={styles.quickButton}
                        onClick={() =>
                            handleQuickSelect(10)
                        }
                    >
                        <TicketIcon />
                        <span>10</span>
                    </button>

                    <button
                        className={styles.quickButton}
                        onClick={() =>
                            handleQuickSelect(25)
                        }
                    >
                        <TicketIcon />
                        <span>25</span>
                    </button>

                    <button
                        className={styles.quickButton}
                        onClick={() =>
                            handleQuickSelect(45)
                        }
                    >
                        <TicketIcon />
                        <span>45</span>
                    </button>
                </div>
                <div className={styles.btn}>
                    Участвовать
                </div>
            </div>
        </Modal>
    )
}

export default GivewayParticipateModal